import Tooltip from './component';
import withTooltip from './hoc';

export {
  Tooltip,
  withTooltip,
}



// WEBPACK FOOTER //
// ./src/Tooltip/index.js